import { useEffect, useState } from 'react';
import type { HealthResponse } from '@nutribot/shared';

type FetchState =
  | { kind: 'loading' }
  | { kind: 'ok'; data: HealthResponse }
  | { kind: 'error'; message: string };

export function App() {
  const [health, setHealth] = useState<FetchState>({ kind: 'loading' });

  useEffect(() => {
    let cancelled = false;
    fetch('/health')
      .then(async (r) => {
        const body = (await r.json()) as HealthResponse;
        if (!cancelled) setHealth({ kind: 'ok', data: body });
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setHealth({
            kind: 'error',
            message: err instanceof Error ? err.message : 'unknown error',
          });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main
      style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        maxWidth: 640,
        margin: '4rem auto',
        padding: '0 1rem',
        lineHeight: 1.5,
      }}
    >
      <h1 style={{ fontSize: '1.75rem', marginBottom: '0.5rem' }}>NutriBot</h1>
      <p style={{ color: '#666', marginTop: 0 }}>
        Dashboard placeholder — M1 scaffold. Real screens arrive in M10/M11.
      </p>

      <section
        style={{
          marginTop: '2rem',
          padding: '1rem 1.25rem',
          border: '1px solid #e5e5e5',
          borderRadius: 8,
          background: '#fafafa',
        }}
      >
        <h2 style={{ fontSize: '1rem', margin: 0, marginBottom: '0.5rem' }}>Worker /health</h2>
        {health.kind === 'loading' && <p>Checking…</p>}
        {health.kind === 'error' && (
          <p style={{ color: '#b00020' }}>Failed to reach Worker: {health.message}</p>
        )}
        {health.kind === 'ok' && (
          <pre style={{ margin: 0, fontSize: '0.85rem', overflowX: 'auto' }}>
            {JSON.stringify(health.data, null, 2)}
          </pre>
        )}
      </section>
    </main>
  );
}
